const addMultipleListeners = (el, types, listener, options, useCapture) => {
  types.forEach(type =>
    el.addEventListener(type, listener, options, useCapture)
  );
};

const consentCheckbox = document.querySelector('#contact-form #consent');
const errorEl = document.querySelector('.v-error-consent');

if (consentCheckbox) {
  consentCheckbox.addEventListener('change', () => {
    if (consentCheckbox.checked) {
      errorEl?.classList.add('hidden');
    } else {
      errorEl?.classList.remove('hidden');
    }
  });
}

function checkConstraints() {
  const constraints = {
    first_name: {
      presence: { allowEmpty: false },
      length: { minimum: 3, message: "must be at least 3 characters" }
    },
    last_name: {
      presence: { allowEmpty: false },
      length: { minimum: 3, message: "must be at least 3 characters" }
    },
    email_address: {
      presence: { allowEmpty: false },
      email: {
        message: value => validate.format("^<strong>%{em}</strong> is not a valid email", { em: value })
      }
    },
    telephone: {
      presence: { allowEmpty: false },
      numericality: { message: "must only contain numbers" },
      format: {
        pattern: /^(07|7|44|\+44|0[1-3]).*$/,
        message: value => validate.format("^<strong>%{num}</strong> is not a valid telephone number", { num: value })
      },
      length: { minimum: 10, maximum: 12 }
    },
    message: {
      presence: { allowEmpty: false },
      length: { minimum: 2 }
    }
  };

  // Collect only visible and enabled fields
  const availableFields = [...document.querySelectorAll('#contact-form [data-validate]')]
    .filter(el => !el.disabled)
    .map(el => el.dataset.validate);

  const availableConstraints = Object.fromEntries(
    availableFields.map(field => [field, constraints[field]])
  );

  document.querySelectorAll('#contact-form [data-validate]').forEach(input => {
    if (input && input.value) {
      setTimeout(() => input.dispatchEvent(new Event('change')), 500);
    }

    addMultipleListeners(input, ['keyup', 'blur'], e => {
      const formValues = Object.fromEntries(
        availableFields.map(field => {
          const el = document.querySelector(`#contact-form [data-validate="${field}"]`);
          return [field, el?.value?.replace(/\s/g, '') ?? null];
        })
      );

      const validationResult = validate(formValues, availableConstraints);
      const field = e.target.dataset.validate;
      const targetEl = document.querySelector(`#contact-form [data-validate="${field}"]`);

      if (!validationResult) {
        document.querySelector('#send-contact-form').disabled = !document.querySelector('#consent')?.checked;
        targetEl?.classList.remove('invalid');
        document.querySelectorAll(`#contact-form .validation-error`).forEach(el => el.remove());
      } else {
        document.querySelector('#send-contact-form').disabled = true;
        if (validationResult[field]) {
          targetEl?.classList.add('invalid');
          document.querySelectorAll(`[data-validate="${field}"] ~ .validation-error`).forEach(el => el.remove());
          validationResult[field].forEach(msg => {
            const error = document.createElement("p");
            error.classList.add('validation-error', 'text-red-500', 'mt-1', 'text-sm');
            error.innerHTML = msg;
            targetEl?.parentElement?.appendChild(error);
          });
        } else {
          targetEl?.classList.remove('invalid');
          document.querySelectorAll(`[data-validate="${field}"] ~ .validation-error`).forEach(el => el.remove());
        }
      }
    });
  });
}

checkConstraints();